import * as types from '../../../actions';

const initialState = {
    items: [],
    status: 0,
    totalPage: 0,
    numRows: 0,
    item: {
        id: '',
        name: '',
        iconFontawesomeClass: '', 
        certificateDetails: '',
        certificateRequired: false,
        showDateRange: false,
        isActive: true,
        sub_sectors: [],
    },
    activity: '',
    count: '',
    errorData: '',
    subSectorObj: [],
};

export default function (state = initialState, action) {
    const response = action.response;
    switch (action.type) {
        case types.SUPERADMIN_SKILL_LIST_SUCCESS:
            if (response.status === 200) {
                if(response.data.results) { // IF REQUEST FROM SUPER ADMIN
                    let totalPage = Math.ceil(response.data.count / response.data.page_size);
                    return {
                        ...state,
                        items:  response.data.results,
                        status: response.status,
                        activity: types.SUPERADMIN_SKILL_LIST_SUCCESS,
                        totalPage: totalPage,
                        numRows: response.data.results.length,
                        count: response.data.count
                    };
                }
                else { // REQUEST FROM AFFILIATE 
                    return {
                        ...state,
                        items:  response.data,
                        status: response.status,
                        activity: types.SUPERADMIN_SKILL_LIST_SUCCESS,
                    };
                }
            } else {
                return {
                    ...state,
                    activity: types.SUPERADMIN_SKILL_LIST_ERROR,
                    status: response.status,
                };
            }

        case types.SUPERADMIN_SKILL_ADD_SUCCESS:
            // FOR ALREADY ADDED SKILL RESPONSE IS 200, WE NEED TO CHECK THE MESSAGE IS "already_exist"
            // {"status":409,"message":"already_exist"}
            if(response?.data?.message && response.data.message=="already_exist") { 
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity: types.SUPERADMIN_SKILL_ADD_ERROR,
                }
            }
            else if (response.status === 200) {
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity: types.SUPERADMIN_SKILL_ADD_SUCCESS,
                }
            } else {
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity: types.SUPERADMIN_SKILL_ADD_ERROR,
                }
            }

        case types.SUPERADMIN_SKILL_EDIT_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    item: {
                        id: response.data.id,
                        name: response.data.skill_name,
                        iconFontawesomeClass: response.data.icon_fontawesome_class,
                        certificateName: response.data.certificate_name,
                        certificateRequired: response.data.certificate_required,
                        showDateRange: response.data.date_range,
                        isActive: response.data.is_active,
                        sub_sectors: response.data.sub_sectors
                    },
                    status: response.status,
                    activity: types.SUPERADMIN_SKILL_EDIT_SUCCESS,
                }
            } else {
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity: types.SUPERADMIN_SKILL_EDIT_ERROR,
                }
            }

        case types.SUPERADMIN_SKILL_UPDATE_SUCCESS:
            // FOR ALREADY ADDED SKILL RESPONSE IS 200, WE NEED TO CHECK THE MESSAGE IS "already_exist"
            // {"status":409,"message":"already_exist"}
            if(response?.data?.message && response.data.message=="already_exist") { 
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity: types.SUPERADMIN_SKILL_ADD_ERROR,
                }
            }
            else if (response.status === 200) {
                return {
                    ...state,
                    items: state.items.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity: types.SUPERADMIN_SKILL_UPDATE_SUCCESS,
                }
            } else {
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity: types.SUPERADMIN_SKILL_UPDATE_ERROR,
                }
            }

        case types.SUPERADMIN_SKILL_DELETE_SUCCESS:
            const id = response.data.id;
            if (response.status === 200) {
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),
                    status: response.status,
                    activity: types.SUPERADMIN_SKILL_DELETE_SUCCESS,
                }
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.SUPERADMIN_SKILL_DELETE_ERROR,
                    errorData: response.data
                }
            }

        case types.SUPERADMIN_SUBSECTOR_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    subSectorObj: response.data,
                    status: response.status,
                    activity: types.SUPERADMIN_SUBSECTOR_LIST_SUCCESS,
                }
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.SUPERADMIN_SUBSECTOR_LIST_ERROR,
                    errorData: response.data
                }
            }

        case types.CLEAR:
            return {
                ...state,
                item: {
                    id: '',
                    name: '',
                    iconFontawesomeClass: '', 
                    certificateDetails: '',
                    certificateRequired: false,
                    showDateRange: false,
                    sub_sectors: []
                },
                activity: '',
                status: 0
            }

        default:
            return state;
    }
};